import React from 'react'
import { isBrowser, isMobile } from 'react-device-detect'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import InputNumber from 'core/components/ui/inputTypeNumber'
import { Row, Col, Card, Slider, Input, ButtonGhost, Form } from 'core/components/ui'
import { font, greys } from 'assets/themes/theme-default'
import { configuratorShape, fundingShape } from '../../shapes'

//import CheckboxFundingCard from './checkbox'
import PriceFundingCard from './price'

const StyledCard = styled(Card)`
  &&& {
    margin: 15px 10px;
    box-shadow: ${props => props.selected && `0 2px 15px rgba(0,0,0,0.4)`};
    .ant-card-body {
      padding-top: 0;
      padding: ${isMobile && '5px 24px'};
    }
    .ant-card-actions {
      background: ${props => props.selected && props.theme.colors.color1.bg};

      > li > span {
        color: ${greys.light4};
        :hover {
          color: ${greys.light4};
        }
      }
    }
  }
`
const ButtonWrapper = styled.div`
  margin: ${isMobile ? '5px 0 0 0' : '25px 0 0 0'};
`

const Description = styled.p`
  font-weight: ${font.weight.base};
  font-size: ${font.size.base};
  color: ${greys.dark3};
  min-height: 100px;
`

const DataWrapper = styled.div`
  margin: ${isMobile ? '0px auto' : '15px auto'};
  text-align: center;
  text-transform: uppercase;
`
const Label = styled.p`
  font-weight: ${font.weight.base};
  font-size: ${font.size.base};
  color: ${greys.dark3};
  margin: 0;
`

const DataSliderWrapper = styled.div`
  margin: 35px auto 15px;
`

const FundingCard = props => {
  //calculatePrice = (max, min) => Math.floor(Math.random() * (max - min) + min)

  //const [inputValue, setInputValue] = useState(0)
  //const [sliderValue, setSliderValue] = useState(0)
  const {
    setConfigurator,
    configurator,
    item,
    form: { getFieldDecorator }
  } = props
  const { fundingList, funding } = configurator
  const currentFunding = fundingList.filter(el => el.label === item.label)

  const handleOnChangeSelection = () => {
    setConfigurator({
      ...configurator,
      funding: funding && funding.label === item.label ? null : item
    })
  }

  const handleSliderChange = value => {
    const extendedFunding = {
      ...currentFunding[0],
      monthly: value
      // price: calculatePrice(value * 10, value * 25)
    }

    const extendedFundingList = [...fundingList]

    const foundIndex = extendedFundingList.findIndex(el => el.label === item.label)

    extendedFundingList[foundIndex] = extendedFunding

    if (funding && funding.label === item.label) {
      setConfigurator({
        ...configurator,
        funding: extendedFunding,
        fundingList: extendedFundingList
      })
    } else {
      setConfigurator({
        ...configurator,
        fundingList: extendedFundingList
      })
    }
  }

  const handleInputChange = e => {
    const extendedFunding = {
      ...currentFunding[0],
      bring: Number(e)
      // price: calculatePrice(300, 600)
    }

    const extendedFundingList = [...fundingList]

    const foundIndex = extendedFundingList.findIndex(el => el.label === item.label)

    extendedFundingList[foundIndex] = extendedFunding

    if (funding && funding.label === item.label) {
      setConfigurator({
        ...configurator,
        funding: extendedFunding,
        fundingList: extendedFundingList
      })
    } else {
      setConfigurator({
        ...configurator,
        fundingList: extendedFundingList
      })
    }
  }

  const getCardAction = () => <PriceFundingCard item={item} />

  const isSelected = !funding ? false : item.label === funding.label
  return (
    <StyledCard
      bordered={false}
      title={item.label}
      actions={[getCardAction()]}
      data-test="component-configurator-funding-fundingCard"
      selected={isSelected}
    >
      <Form>
        {isBrowser && (
          <Description data-test="configurator-funding-fundingCard-description">
            {item.description}
          </Description>
        )}
        <DataWrapper>
          <Label data-test="configurator-funding-fundingCard-label-bring">
            <FormattedMessage id="configurator-funding-card-label-1" />
          </Label>
          <Form.Item>
            {getFieldDecorator('zipCode', {
              initialValue: item.bring
            })(
              <InputNumber
                // defaultValue={inputValue}
                onChange={e => handleInputChange(e)}
                data-test="configurator-funding-fundingCard-input-bring"
              />
            )}
          </Form.Item>
        </DataWrapper>
        <DataWrapper>
          <Label data-test="configurator-funding-fundingCard-label-price">
            <FormattedMessage id="configurator-funding-card-label-2" />
          </Label>
          <Input
            value={configurator.price}
            disabled
            data-test="configurator-funding-fundingCard-imput-price"
          />
        </DataWrapper>
        <DataSliderWrapper>
          <Slider
            defaultValue={item.monthly}
            step={item.step}
            max={item.maxStep}
            min={item.minStep}
            dots
            onChange={value => handleSliderChange(value)}
            data-test="configurator-funding-fundingCard-slider"
          />
          <Row type="flex">
            <Col span={8} data-test="configurator-funding-fundingCard-slider-mounth-min">
              <FormattedMessage
                id="configurator-funding-card-month"
                values={{ months: item.minStep }}
              />
            </Col>
            <Col
              span={8}
              offset={8}
              style={{ textAlign: 'right' }}
              data-test="configurator-funding-fundingCard-slider-mounth-max"
            >
              <FormattedMessage
                id="configurator-funding-card-month"
                values={{ months: item.maxStep }}
              />
            </Col>
          </Row>
          <ButtonWrapper>
            <ButtonGhost onClick={handleOnChangeSelection} block>
              {isSelected ? (
                <FormattedMessage id="configurator-funding-card-cta-off" />
              ) : (
                <FormattedMessage id="configurator-funding-card-cta-on" />
              )}
            </ButtonGhost>
          </ButtonWrapper>
        </DataSliderWrapper>
      </Form>
    </StyledCard>
  )
}

FundingCard.propTypes = {
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired,
  item: fundingShape.isRequired,
  form: PropTypes.shape().isRequired
}

export default Form.create({ name: 'FundingCard' })(FundingCard)
